import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-names.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { Questions, Routes } from "./Constants";
import { QUESTION_TO_PATH_MOBILE } from "./RestartProgress/consts";
export var getFirstUnansweredQuestionRoute = function getFirstUnansweredQuestionRoute(validKeys) {
  /* It appears to be slightly safer to use Object.getOwnPropertyNames over Object.keys
   * for guaranteed iteration over insertion order
   * https://www.stefanjudis.com/today-i-learned/property-order-is-predictable-in-javascript-objects-since-es2015/
   * https://stackoverflow.com/a/38218582
   */
  var firstUnansweredQuestionKey = Object.getOwnPropertyNames(Questions).find(function (key) {
    return !validKeys.includes(key);
  });
  if (validKeys.length === 0 || firstUnansweredQuestionKey === 'stateOfResidence') {
    return Routes.Eligibility.NationalityQuestion;
  }
  return QUESTION_TO_PATH_MOBILE.get(firstUnansweredQuestionKey);
};